function Djibouti({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1055)">
  <path d="M14.6087 17.3913C14.6087 17.3913 4.69565 4.68406 4.68628 4.68631C7.58165 1.79088 11.5817 0 16 0C24.8365 0 32 7.1635 32 16L14.6087 17.3913Z" fill="#338AF3"/>
  <path d="M14.6087 16C14.6087 16 4.69565 27.3159 4.68628 27.3137C7.58165 30.2091 11.5817 32 16 32C24.8365 32 32 24.8365 32 16H14.6087Z" fill="#6DA544"/>
  <path d="M4.68628 4.68555C-1.56209 10.9339 -1.56209 21.0646 4.68628 27.313C7.26834 24.731 9.75165 22.2477 16 15.9993L4.68628 4.68555Z" fill="#F0F0F0"/>
  <path d="M6.47561 11.8262L7.51154 15.0147H10.8644L8.15204 16.9854L9.18792 20.174L6.47561 18.2034L3.76317 20.174L4.79929 16.9854L2.08691 15.0147H5.43954L6.47561 11.8262Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Djibouti;
